export default __webpack_public_path__ + "static/media/logo-linkedin.d19b6290.svg";